module.exports = __webpack_public_path__ + "static/google-12ce2116411d544583503ad29baaab87.png";